// extracted by mini-css-extract-plugin
module.exports = {"axisY":"YAxis_axisY__5XMaL"};